module.exports = __webpack_public_path__ + "img/homeTag-icon-3.e1a764d7.svg";